module.exports = __webpack_public_path__ + "img/oaks-nest-study-4.242c32c0.jpeg";